import { createClient } from '@/shared/api';
import type {
  UpdateUserInput,
  UpdateUserMutation,
  UpdateUserMutationVariables,
} from '@/shared/api';
import UPDATE_USER_MUTATION from '../mutations/updateUser';

/**
 * Saves changes to the signed-in user's profile fields. Runs UPDATE_USER_MUTATION with the payload, throws updateUser.message when isSuccess is false and returns the updated user.
 *
 * @param userData - Profile fields to overwrite.
 * @returns The updated user record.
 */
const handleUpdateUser = async (userData: UpdateUserInput) => {
  const client = createClient();
  const result = await client.mutate<UpdateUserMutation, UpdateUserMutationVariables>({
    mutation: UPDATE_USER_MUTATION,
    variables: { userData },
  });
  const { data } = result;
  // data is guaranteed by the mutation contract; downstream code already assumes it exists
  const { updateUser } = data!;
  if (!updateUser.isSuccess) {
    throw new Error(updateUser.message ?? undefined);
  }
  return updateUser.user;
};

export default handleUpdateUser;
